var VariablePaymentType;
(function (VariablePaymentType) {
    VariablePaymentType[VariablePaymentType["TeamManager"] = 0] = "TeamManager";
    VariablePaymentType[VariablePaymentType["Level"] = 1] = "Level";
    VariablePaymentType[VariablePaymentType["Director"] = 2] = "Director";
    VariablePaymentType[VariablePaymentType["Fixed"] = 3] = "Fixed";
    VariablePaymentType[VariablePaymentType["None"] = 4] = "None";
})(VariablePaymentType || (VariablePaymentType = {}));
export default VariablePaymentType;
